// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-slider/сomponents/auto-slider/styles.less
// module id = 1145
// module chunks = 10